"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Modal = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal"));
var _CheckEmail = _interopRequireDefault(require("./components/screens/CheckEmail"));
var _KiwiLogin = _interopRequireDefault(require("./components/KiwiLogin"));
var _Intro = _interopRequireDefault(require("./components/Intro"));
var _FareLock = _interopRequireDefault(require("./components/FareLock"));
var _createMagicLink = _interopRequireDefault(require("./mutations/createMagicLink"));
var _errors = _interopRequireDefault(require("../../consts/errors"));
var _context = require("../../services/auth/context");
var _context2 = require("../../services/brand/context");
var _context3 = require("../../services/log/context");
var _context4 = require("../../services/intl/context");
var _MagicLogin = require("../../records/MagicLogin");
var _GetSingleBooking = _interopRequireDefault(require("./components/GetSingleBooking"));
var _events = require("./consts/events");
var _LinkBookings = _interopRequireDefault(require("./components/LinkBookings"));
var _NoAccountFound = _interopRequireDefault(require("./components/NoAccountFound"));
var _VerifyEmail = _interopRequireDefault(require("./components/VerifyEmail"));
var _OldBookings = _interopRequireDefault(require("./components/OldBookings"));
var _EmailLogin = _interopRequireDefault(require("./components/EmailLogin"));
var _RequiredLogin = _interopRequireDefault(require("./components/screens/RequiredLogin"));
var _emailCorrector = _interopRequireDefault(require("../../services/input/emailCorrector"));
var _NewIntroScreen = _interopRequireDefault(require("./components/NewIntroScreen"));
var _OneTimePassword = _interopRequireDefault(require("./components/OneTimePassword"));
var _usePublishLoginAbandoned = _interopRequireDefault(require("./consts/events/business/usePublishLoginAbandoned"));
var _client = require("../../services/platform/client");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getInitialScreen = (initialScreen, isSkyUsersV2) => {
  if (initialScreen == null || initialScreen === "intro" || initialScreen === "newIntroSignIn") {
    return isSkyUsersV2 ? "newIntroSignIn" : "intro";
  }
  return initialScreen;
};

// list of login screens which we consider to be the fulfilment of the login flow
const successfulScreens = ["signUpConfirmation", "magicLink", "resetPassword"];
// eslint-disable-next-line fp/no-class
class MagicLoginWithoutContext extends React.Component {
  static defaultProps = {
    type: "mmb",
    hideCloseButton: false
  };
  constructor(props) {
    var _props$fixedAccount, _ref;
    super(props);
    const fixedAccountEmail = (_props$fixedAccount = props.fixedAccount) === null || _props$fixedAccount === void 0 ? void 0 : _props$fixedAccount.email;
    const initialScreen = props.initialScreen;
    const {
      initialEmail
    } = props;
    const email = (_ref = initialEmail !== null && initialEmail !== void 0 ? initialEmail : fixedAccountEmail) !== null && _ref !== void 0 ? _ref : "";
    this.state = {
      email,
      emailSuggestion: "",
      screen: getInitialScreen(initialScreen, props.isSkyUsersV2),
      isSendingEmail: false,
      magicLinkError: null,
      googleError: "",
      facebookError: null,
      loginFlowFulfilled: false,
      otpTransactionId: null,
      otpFlow: null
    };
  }
  componentDidMount() {
    const {
      log,
      type,
      isSimplifiedLoginFlow,
      hideCloseButton,
      customTitle,
      customDescription,
      isSkyUsersV2
    } = this.props;
    const {
      screen
    } = this.state;
    log(_events.MAGIC_LOGIN_MODAL_SHOWN, {
      screen,
      type,
      isSimplifiedLoginFlow,
      customTitle,
      customDescription,
      hideCloseButton,
      isSkyUsersV2
    });
  }
  componentWillUnmount() {
    const {
      log,
      type,
      setAppleIdToken
    } = this.props;
    const {
      loginFlowFulfilled,
      screen
    } = this.state;
    setAppleIdToken(null);
    if (loginFlowFulfilled) {
      log(_events.LOGIN_PATH_FULFILLED, {
        screen
      });
      return;
    }
    log(_events.LOGIN_ABANDONED, {
      screen,
      type
    });
  }
  handleSignInFulfilled = () => {
    const {
      onSignInFulfill,
      onClose
    } = this.props;
    this.setState({
      loginFlowFulfilled: true
    }, () => {
      if (onSignInFulfill != null) {
        onSignInFulfill();
      }
      onClose();
    });
  };
  handleClose = () => {
    const {
      onClose,
      publishLoginAbandoned
    } = this.props;
    const {
      screen
    } = this.state;

    // Track modal closed event with the appropriate reason based on the current screen
    if (screen === "oneTimePasswordSignIn" || screen === "oneTimePasswordSignUp") {
      publishLoginAbandoned("otp_modal_closed");
    } else if (screen === "getSingleBooking") {
      publishLoginAbandoned("alternative_method_modal_closed");
    } else {
      publishLoginAbandoned("login_modal_closed");
    }
    onClose();
  };
  handleOtpFlowChange = otpFlow => {
    this.setState({
      otpFlow
    });
  };
  handleEmailChange = e => {
    const target = e.target;
    this.setState({
      email: target.value,
      emailSuggestion: (0, _emailCorrector.default)(target.value)
    });
  };
  handleEmailCorrection = () => {
    const {
      email,
      emailSuggestion
    } = this.state;
    const {
      log
    } = this.props;
    if (emailSuggestion !== null) {
      log(_events.EMAIL_CORRECTION, {
        email,
        emailSuggestion
      });
      this.setState({
        email: emailSuggestion,
        emailSuggestion: ""
      });
    }
  };
  handleOtpTransactionIdChange = value => {
    this.setState({
      otpTransactionId: value
    });
  };
  handleToIntro = () => {
    const {
      onContinueToSignIn,
      isSkyUsersV2
    } = this.props;
    if (typeof onContinueToSignIn === "function") {
      onContinueToSignIn();
      return;
    }
    if ((0, _client.isWebview)()) {
      // eslint-disable-next-line no-console
      console.warn("In webviews, please use onContinueToSignIn to open native login modal.");
      return;
    }
    this.handleChangeScreen(isSkyUsersV2 ? "newIntroSignIn" : "intro");
  };
  handleAppleLogin = () => {
    const {
      onAppleAuth,
      log
    } = this.props;
    const {
      screen
    } = this.state;
    onAppleAuth().then(res => {
      if (res.connectAccount) {
        this.setState({
          screen: "linkBookings",
          otpFlow: "appleLogin"
        });
      } else {
        log(_events.LOGIN_VIA_APPLE, {
          loading: _MagicLogin.Loading.COMPLETED
        });
        this.handleSignInFulfilled();
      }
      return Promise.resolve();
    }).catch(err => log(_events.LOGIN_VIA_APPLE_FAILED, {
      screen,
      error: String(err)
    }));
  };
  handleEmailLogin = () => {
    this.handleChangeScreen("emailLogin");
  };
  handleFacebookLogin = () => {
    const {
      onFacebookAuth,
      log
    } = this.props;
    const {
      screen
    } = this.state;
    log(_events.LOGIN_VIA_FACEBOOK, {
      loading: _MagicLogin.Loading.STARTED
    });
    this.setState({
      facebookError: null
    });
    onFacebookAuth().then(() => {
      log(_events.LOGIN_VIA_FACEBOOK, {
        loading: _MagicLogin.Loading.COMPLETED
      });
      this.handleSignInFulfilled();
    }).catch(err => {
      if ("error" in err) {
        this.setState({
          facebookError: err.error
        });
        log(_events.LOGIN_VIA_FACEBOOK_FAILED, {
          screen,
          error: String(err)
        });
        return;
      }
      log(_events.LOGIN_VIA_FACEBOOK_FAILED, {
        screen,
        error: String(err)
      });
    });
  };
  handleGoogleLogin = () => {
    const {
      onGoogleAuth,
      log
    } = this.props;
    const {
      screen
    } = this.state;
    log(_events.LOGIN_VIA_GOOGLE, {
      loading: _MagicLogin.Loading.STARTED
    });
    this.setState({
      googleError: ""
    });
    onGoogleAuth().then(() => {
      log(_events.LOGIN_VIA_GOOGLE, {
        loading: _MagicLogin.Loading.COMPLETED
      });
      this.handleSignInFulfilled();
    }).catch(err => {
      if ("error" in err) {
        this.setState({
          googleError: err.error
        });
        log(_events.LOGIN_VIA_GOOGLE_FAILED, {
          screen,
          error: err.error
        });
        return;
      }
      log(_events.LOGIN_VIA_GOOGLE_FAILED, {
        screen,
        error: String(err)
      });
    });
  };
  handleCreateMagicLink = () => {
    const {
      email
    } = this.state;
    const {
      brand,
      log,
      origin,
      apiLanguage
    } = this.props;
    this.setState({
      isSendingEmail: true,
      magicLinkError: null
    });
    (0, _createMagicLink.default)({
      email,
      brandId: brand.id,
      origin,
      apiLanguage
    }).then(res => {
      this.setState({
        isSendingEmail: false
      });
      if ("success" in res) {
        log(_events.MAGIC_LINK_SENT, {});
        this.handleChangeScreen("magicLink");
        return;
      }
      log(_events.LOGIN_STEP_FAILED, {
        operation: "createMagicLink",
        error: res.error || ""
      });
      this.setState({
        magicLinkError: _errors.default.general
      });
    }).catch(err => {
      log(_events.CRITICAL_LOGIN_ERROR, {
        error: String(err),
        operation: "createMagicLink"
      });
      this.setState({
        isSendingEmail: false,
        magicLinkError: _errors.default.general
      });
    });
  };
  handleSignUpConfirmation = () => {
    this.handleChangeScreen("signUpConfirmation");
  };
  handleContinueAsGuest = () => {
    if (typeof this.props.onContinueAsGuest === "function") {
      this.props.log(_events.REQUIRED_LOGIN_CONTINUE_AS_GUEST_CLICKED, {});
      this.props.onContinueAsGuest();
    }
  };
  handleChangeScreen = screen => {
    const {
      log
    } = this.props;
    log(_events.SCREEN_CHANGED, {
      screen
    });
    this.setState({
      screen,
      loginFlowFulfilled: successfulScreens.includes(screen)
    });
  };
  render() {
    const {
      brand,
      disableSocialLogin,
      onGetSimpleToken,
      fixedAccount,
      isSimplifiedLoginFlow,
      intl,
      hideCloseButton,
      customTitle,
      customDescription,
      triggerRef
    } = this.props;
    const {
      screen,
      email,
      emailSuggestion,
      magicLinkError,
      googleError,
      facebookError,
      otpTransactionId,
      otpFlow
    } = this.state;
    const {
      id: brandId
    } = brand;
    // disable automatically for whitelabels if prop not provided
    const disableLoginViaSocials = disableSocialLogin != null ? disableSocialLogin : brandId !== "kiwicom";
    const hasCustomHeader = screen === "newIntroSignIn" || screen === "newIntroSignUp" || screen === "oneTimePasswordSignIn" || screen === "oneTimePasswordSignUp" || screen === "verifyEmail";
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.default, {
      size: "extraSmall",
      onClose: this.handleClose,
      hasCloseButton: hideCloseButton !== true,
      dataTest: "MagicLogin",
      preventOverlayClose: true,
      labelClose: intl.formatMessage({
        id: "orbit.button_close"
      }),
      ariaLabelledby: hasCustomHeader ? "magic-login-header" : undefined,
      triggerRef: triggerRef,
      children: [(screen === "intro" || screen === "signUp") && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Intro.default, {
        customTitle: customTitle,
        customDescription: customDescription,
        disableSocialLogin: disableLoginViaSocials,
        onAppleLogin: this.handleAppleLogin,
        onGoogleLogin: this.handleGoogleLogin,
        onFacebookLogin: this.handleFacebookLogin,
        onChangeScreen: this.handleChangeScreen,
        googleError: googleError,
        facebookError: facebookError
      }), (screen === "newIntroSignUp" || screen === "newIntroSignIn") && /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewIntroScreen.default, {
        email: email,
        emailSuggestion: emailSuggestion,
        onEmailChange: this.handleEmailChange,
        onEmailCorrection: this.handleEmailCorrection,
        onOtpTransactionIdChange: this.handleOtpTransactionIdChange,
        onChangeScreen: this.handleChangeScreen,
        screen: screen,
        disableSocialLogin: disableLoginViaSocials
      }), screen === "fareLock" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FareLock.default, {
        disableSocialLogin: disableLoginViaSocials,
        onAppleLogin: this.handleAppleLogin,
        onGoogleLogin: this.handleGoogleLogin,
        onFacebookLogin: this.handleFacebookLogin,
        onChangeScreen: this.handleChangeScreen,
        googleError: googleError,
        facebookError: facebookError
      }), (screen === "oneTimePasswordSignIn" || screen === "oneTimePasswordSignUp") && /*#__PURE__*/(0, _jsxRuntime.jsx)(_OneTimePassword.default, {
        onChangeScreen: this.handleChangeScreen,
        onSignInFulfilled: this.handleSignInFulfilled,
        screen: screen,
        email: email,
        otpTransactionId: otpTransactionId,
        onOtpTransactionIdChange: this.handleOtpTransactionIdChange
      }), screen === "linkBookings" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LinkBookings.default, {
        onChangeScreen: this.handleChangeScreen,
        onEmailChange: this.handleEmailChange,
        email: email,
        onOtpTransactionIdChange: this.handleOtpTransactionIdChange
      }), screen === "oldBookings" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_OldBookings.default, {
        onChangeScreen: this.handleChangeScreen
      }), screen === "noAccountFound" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoAccountFound.default, {
        onChangeScreen: this.handleChangeScreen
      }), screen === "verifyEmail" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerifyEmail.default, {
        email: email,
        onChangeScreen: this.handleChangeScreen,
        otpTransactionId: otpTransactionId,
        onOtpTransactionIdChange: this.handleOtpTransactionIdChange,
        otpFlow: otpFlow,
        onSignInFulfilled: this.handleSignInFulfilled
      }), screen === "emailLogin" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmailLogin.default, {
        email: email,
        emailSuggestion: emailSuggestion,
        brandId: brand.id,
        magicLinkError: magicLinkError,
        isSimplifiedLoginFlow: isSimplifiedLoginFlow,
        onChangeScreen: this.handleChangeScreen,
        onEmailChange: this.handleEmailChange,
        onEmailCorrection: this.handleEmailCorrection,
        onOtpTransactionIdChange: this.handleOtpTransactionIdChange,
        onOtpFlowChange: this.handleOtpFlowChange,
        onSendMagicLink: this.handleCreateMagicLink
      }), screen === "password" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_KiwiLogin.default, {
        email: email,
        canChangeEmail: fixedAccount == null,
        brandId: brand.id,
        onChangeScreen: this.handleChangeScreen,
        onFulfill: this.handleSignInFulfilled
      }), (screen === "signUpConfirmation" || screen === "magicLink" || screen === "resetPassword") && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckEmail.default, {
        reason: screen,
        email: email
      }), screen === "getSingleBooking" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_GetSingleBooking.default, {
        onBack: this.handleToIntro,
        onFulfill: this.handleSignInFulfilled,
        onGetSimpleToken: onGetSimpleToken
      }), screen === "requiredLogin" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RequiredLogin.default, {
        onHandleToIntro: this.handleToIntro,
        onHandleContinueAsGuest: this.handleContinueAsGuest
      })]
    });
  }
}
const MagicLogin = props => {
  const intl = (0, _reactIntl.useIntl)();
  const {
    log
  } = (0, _context3.useLog)();
  const auth = (0, _context.useAuth)();
  const brand = (0, _context2.useBrand)();
  const {
    language
  } = (0, _context4.useIntl)();
  const publishLoginAbandoned = (0, _usePublishLoginAbandoned.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(MagicLoginWithoutContext, {
    ...props,
    apiLanguage: language.api,
    log: log,
    intl: intl,
    onFacebookAuth: auth.onFacebookAuth,
    onGoogleAuth: auth.onGoogleAuth,
    onAppleAuth: auth.onAppleAuth,
    setAppleIdToken: auth.setAppleIdToken,
    brand: brand,
    publishLoginAbandoned: publishLoginAbandoned,
    isSimplifiedLoginFlow: props.isSimplifiedLoginFlow,
    isSkyUsersV2: props.isSkyUsersV2
  });
};
var _default = exports.default = MagicLogin;